import React from "react";
import ReactDOM from "react-dom";
import TableWithAPI from "./components/TableWithAPI";


function App() {
  return (
    <div className="App">
      <div className="app-container">
        <div className="grid-container">
          <TableWithAPI />
        </div>
      </div>
    </div>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
